import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    DatePicker,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag,
    Select,

} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import ScrappedListForm from "./scrapped_list_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import { ScrappedListExcelExport } from "./scrapped_list_excel_export"
import { Spinner } from "../../ui/spinner";
const ScrappedListEdit = ({
    keyPrefix = "cataloging.serial_orderlist_management",

}) => {
    const navigate = useNavigate()
    const { t } = useTranslation('translation', { keyPrefix })
    const [searchParams, setSearchParams] = useSearchParams();
    const list_id = searchParams.get('list_id');
    const mode = searchParams.get('mode');
    const readOnly = mode === "view"
    const [form] = Form.useForm();
    const [reloadCount, setReloadCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                navigate(`../scrapped_list_management?mode=edit&list_id=${values?.list_id}`)
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                navigate(`../scrapped_list_management`)
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                // actionRef.current.reloadAndRest();
                // setSelectedRowKeys([]);
                // setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(values?.message || t('add_failure'));
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(values?.message || t('modify_failure'));
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                // actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            // setModalLoading(false);
            // setModalOpen(false);
        }
        setLoading(false);
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setLoading(true);

    };
    const onFormFinish = (value) => {
        if (mode === "new") {
            ScrappedListController.postData([
                value
            ])
        }
        else if (mode === "edit") {
            ScrappedListController.patchData([
                value
            ])
        }
    }
    const dataReload = (list_id) => {
        ScrappedListController.getData({
            list_id: list_id
        }).then((response) => {
            let data = response?.data || []
            let firstData = data.find((ele) => true)
            let list_task_data = [{}]
            if (firstData?.list_task_data.length !== 0) {
                list_task_data = firstData?.list_task_data
            }
            form.setFieldsValue({
                ...firstData,
                create_time: dayjs(firstData?.create_time).format('YYYY-MM-DD HH:mm:ss'),
                list_task_data
            })
            setReloadCount((pre) => pre + 1)
        })
    }
    const ScrappedListController = useCRUDController({
        apiRoute: "/library/scrapped_list",
        includePatchErrorDetails: true,
        onFinish,
        onBefore
    })
    const AuthorisedCategoryValueController = useCRUDController({
        apiRoute: "/koha/authorised_values",
        //  onFinish,
        // onBefore
    })
    useEffect(() => {
        if (list_id) {
            dataReload(list_id)
        }
        else {

        }
    }, [list_id])

    useEffect(() => {
        AuthorisedCategoryValueController.getData({
            category: "WITHDRAWN"
        })
        if (mode === "new") {
            form.setFieldsValue({
                list_task_data: [{

                }]
            })
        }
    }, [])
    return (
        <Row gutter={[10, 20]} >
            <Col span={24}>
                <Row justify="space-between">
                    <Col>
                        <Typography.Title level={2}>{t('')}</Typography.Title>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]}>
                            {readOnly && <Col>
                                <Button
                                    loading={loading}
                                    onClick={() => navigate(-1)}
                                    type="default"
                                >
                                    返回
                                </Button>
                            </Col>}
                            <Col>
                                <ScrappedListExcelExport
                                    propsLoading={loading}
                                    data={ScrappedListController?.ResponseData?.find((ele) => true)}
                                />
                            </Col>
                            {!readOnly && <Col>
                                <Button
                                    loading={loading}
                                    onClick={() => {
                                        navigate(`../scrapped_list_management`)
                                    }}
                                    type="default" >
                                    {t('cancel')}
                                </Button>
                            </Col>}
                            {!readOnly && <Col>
                                <Button
                                    loading={loading}
                                    onClick={() => {
                                        form.submit()
                                    }}
                                >
                                    {t('save')}
                                </Button>
                            </Col>}
                        </Row>
                    </Col>
                </Row>
            </Col>
            <Col span={24} hidden={!loading}>
                <div className="flex items-center justify-center p-8 border rounded-lg">
                    <Spinner variant="icon" size="large" color="text-blue-500" />
                </div>
            </Col>
            <Col span={24} hidden={loading}>
                <ScrappedListForm
                    propsForm={form}
                    onFormFinish={onFormFinish}
                    propsReloadCount={reloadCount}
                    withdrawnOptions={AuthorisedCategoryValueController?.ResponseData?.map((value) => {
                        return {
                            label: value?.description_opac,
                            value: value?.id,
                            ...value
                        }
                    })}
                    readOnly={readOnly}
                />
            </Col>

        </Row>
    );
};
export default ScrappedListEdit;
